function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.9,
  d: "M13 1C19.626 1 25 6.372 25 13C25 19.628 19.626 25 13 25C6.372 25 1 19.628 1 13C1 6.372 6.372 1 13 1ZM13 3C7.477 3 3 7.477 3 13C3 18.523 7.477 23 13 23C18.522 23 23 18.522 23 13C23 7.478 18.522 3 13 3ZM12.5 7C12.7652 7 13.0196 7.10536 13.2071 7.29289C13.3946 7.48043 13.5 7.73478 13.5 8V13.104L18.375 15.073C18.4976 15.1216 18.6094 15.194 18.7039 15.286C18.7984 15.378 18.8737 15.4878 18.9256 15.6091C18.9775 15.7303 19.0049 15.8607 19.0062 15.9926C19.0076 16.1244 18.9828 16.2553 18.9333 16.3776C18.8838 16.4998 18.8107 16.6111 18.718 16.705C18.6254 16.7988 18.5151 16.8735 18.3935 16.9245C18.2719 16.9756 18.1414 17.0021 18.0095 17.0025C17.8776 17.003 17.7469 16.9773 17.625 16.927L12.125 14.705C11.9403 14.6303 11.7822 14.5022 11.6709 14.337C11.5595 14.1718 11.5 13.9772 11.5 13.778V8C11.5 7.73478 11.6054 7.48043 11.7929 7.29289C11.9804 7.10536 12.2348 7 12.5 7V7Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 13,
  y1: 1,
  x2: 13,
  y2: 25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6CC584"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#71CC8B"
})));

var SvgWatchActive = function SvgWatchActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatchActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watch__active.3057da70.svg";
export { ForwardRef as ReactComponent };